export default {
    "results": {
        "viewTitle": "Vue : {text}",
        "unselectableViewDisplay": "<Autre>",
        "resultsListView": {
            "display": "Liste",
            "selectDocument": "Sélectionner le document",
            "unselectDocument": "Désélectionner le document",
            "previewPopup": "Document Navigator",
            "previewInCurrentPage": "Document Navigator (dans la page courante)",
            "previewInNewTab": "Document Navigator (dans un nouvel onglet)",
            "showMetadata": "Détails",
            "showLabels": "Libellés"
        },
        "resultsGridView": {
            "display": "Grille",
            "selectDocument": "Sélectionner le document",
            "unselectDocument": "Désélectionner le document",
            "selectDocuments": "Sélectionner les documents",
            "unselectDocuments": "Désélectionner les documents "
        },
        "viewPageSize": "Nombre de résultats par page",
        "viewUpdateApply": "Appliquer",
        "warningNoViewForTab": "L'onglet '{tab}' n'est associé à aucune vue.",
        "warningCannotDisplayTabOnView": "L'onglet '{tab}' ne peut pas être affiché dans la vue '{view}' car il n'est pas inclus dans la configuration de la vue.",

        "resultsAllTab": "Tous",
        "resultsTextTab": "Texte",
        "results_all_tab": "Tous",
        "results_text_tab": "Texte",
    }
};
